import { render, staticRenderFns } from "./SideNavOlva.vue?vue&type=template&id=2d14e8ad"
import script from "./SideNavOlva.vue?vue&type=script&lang=js"
export * from "./SideNavOlva.vue?vue&type=script&lang=js"
import style0 from "./SideNavOlva.vue?vue&type=style&index=0&id=2d14e8ad&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports